import React, { useEffect, useMemo } from "react";
import PopularBooks from "./PopularBooks";
import NewDishes from "./NewBooks";
import Highlights from "./Highlights";
import Advertisement from "./Advertisement";
import ActiveUsers from "./ActiveUsers";
import { Container } from "@mui/material";
import { useDispatch } from "react-redux";
import { Dispatch } from "@reduxjs/toolkit";
import { setNewBooks, setPopularBooks, setTopUsers } from "./slice";
import { Product } from "../../../lib/types/product";
import ProductService from "../../services/ProductService";
import { ProductCollection } from "../../../lib/enums/product.enum";
import "../../../css/home.css";
import MemberService from "../../services/MemberService";
import { Member } from "../../../lib/types/member";

/** REDUX SLICE & SELECTOR */
const actionDispatch = (dispatch: Dispatch) => ({ // reducer ga beryapmiz
    setPopularBooks: (data: Product[]) => dispatch(setPopularBooks(data)),
    setNewBooks: (data: Product[]) => dispatch(setNewBooks(data)),
    setTopUsers: (data: Member[]) => dispatch(setTopUsers(data)),
});

export default function HomePage() {
    const dispatch = useDispatch();
    const { setPopularBooks, setNewBooks, setTopUsers } = useMemo(() => actionDispatch(dispatch), [dispatch]);
    
    useEffect(() => {
        // backend server data fetch => Data
    const product = new ProductService();
    product.getProducts({
        page: 1,
        limit: 4,
        order: "productViews",
        productCollection: ProductCollection.FICTION,
     })
     .then(data => {
         setPopularBooks(data)
     })
     .catch((err) => console.log(err));

     product.getProducts({
        page: 1,
        limit: 4,
        order: "createdAt",
        productCollection: ProductCollection.FICTION,
      })
     .then(data => setNewBooks(data))
     .catch((err) => console.log(err));

    const member = new MemberService();
    member
      .getTopUsers()
      .then((data) => setTopUsers(data))
      .catch((err) => console.log(err));

    }, [setNewBooks, setPopularBooks, setTopUsers]); 
    
    

    return (
        <div className={"homepage"}>
            <section className="home-ink-statement" aria-labelledby="home-ink-title">
                <Container>
                    <div className="home-ink-statement__inner">
                        <p className="home-ink-statement__eyebrow">Est. 2024</p>
                        <h1 id="home-ink-title" className="home-ink-statement__head">
                            <span className="home-ink-statement__line home-ink-statement__line--lead">
                                Where <em>Ink</em> Meets
                            </span>
                            <span className="home-ink-statement__line home-ink-statement__line--accent">
                                <em>Insight</em>
                            </span>
                        </h1>
                    </div>
                </Container>
            </section>
            
            <PopularBooks />
            <NewDishes />
            <Highlights />
            <Advertisement />
            <ActiveUsers />
        </div>
    );
}
